import { render, staticRenderFns } from "./RejectCommentLayout.vue?vue&type=template&id=1a35c6da&scoped=true"
import script from "./RejectCommentLayout.vue?vue&type=script&lang=js"
export * from "./RejectCommentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35c6da",
  null
  
)

export default component.exports